module.exports = __webpack_public_path__ + "static/media/airports.f0211a74.csv";